import { inject } from "inversify-props";
import { HttpService } from "../HttpService";
import { Config } from "./Config";

export class ConfigService {
  @inject("HttpService") httpService: HttpService;

  config: Config = {};

  public async load() {
    try {
      const data = await this.httpService.getText(
        "/cr-global-footer/footer_env"
      );
      const splitData = data.split("\n");
      for (const value of splitData) {
        const keypair = value.split("=");
        if (keypair && keypair.length > 1) {
          this.config[keypair[0]] = keypair[1].replace(/(^")|("$)/g, "");
        }
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  public getConfig(key: string) {
    const value = this.config[key];
    return value;
  }
}
